<div *ngFor="let trustAnchor of trustAnchors">
    <div class="grid-x bold-text" [ngClass]="trustAnchorsChange| defineDomainViewCss: trustAnchor: 'trustAnchor'">
        <div class="cell large-1 medium-2 small-12 wrap-text"><span>{{trustAnchor.keyTag}} </span>
        </div>
        <div class="cell large-1 medium-2 small-12 wrap-text"><span>{{trustAnchor | trustAnchorValueExtractor : 'algorithm'}}</span></div>
        <div class="cell large-1 medium-2 small-12 wrap-text"><span>{{trustAnchor | trustAnchorValueExtractor : 'digestType'}}</span></div>
        <div class="cell large-9 medium-6 small-12 wrap-text"><span>{{trustAnchor.digest}}</span></div>
    </div>
</div>
<div class="grid-x last-update-button-section">
    <label>{{lastchange | lastChange}}</label>
    <button *ngIf="!viewMode" class="iana-button" (click)="onEdit()" [disabled]="!hasTechnicalPermission || !(pendingRequestChangeID | checkNull)" id="update">Modify</button>
</div>
